export interface MultaPolicia {
  id?: number;
  folio: string;
  fechaInfraccion?: string;
  lugarInfraccion?: string | null;
  latitud?: number | null;
  longitud?: number | null;
  numeroPlaca: string;
  vigencia?: string | null;
  tipoVehiculo?: string | null;
  entidad?: string | null;
  marca?: string | null;
  modeloVehiculo?: string | null;
  tipo: string;
  color?: string | null;
  placasCirculacion?: string | null;
  ciudadano?: string | null;
  propietarioVehiculo?: string | null;
  domicilioConductor?: string | null;
  articuloViolado?: string | null;
  fraccion?: string | null;
  descripcion?: string | null;
  nombreOficial?: string | null;
  gradoOficial?: string | null;
  monto: number;
  estatus?: string;
  garantia?: string | null;
  fecha?: string;
  creadaEn?: string;
  actualizadaEn?: string;
}

export const generateMultaPDF = async (multaData: MultaPolicia) => {
  try {
    console.log('=== INICIANDO GENERACIÓN DE PDF ===');
    console.log('Datos de la multa:', multaData);
    console.log('Campos específicos:');
    console.log('- folio:', multaData.folio);
    console.log('- ciudadano:', multaData.ciudadano);
    console.log('- numeroPlaca:', multaData.numeroPlaca);
    console.log('- lugarInfraccion:', multaData.lugarInfraccion);
    console.log('- monto:', multaData.monto);
    console.log('- estatus:', multaData.estatus);
    
    // Leer la plantilla HTML
    console.log('Obteniendo plantilla HTML...');
    const response = await fetch('/multas/ticketmulta.html');
    console.log('Response status:', response.status);
    console.log('Response ok:', response.ok);
    
    if (!response.ok) {
      throw new Error(`Error al cargar plantilla: ${response.status} ${response.statusText}`);
    }
    
    let htmlTemplate = await response.text();
    console.log('Plantilla cargada, longitud:', htmlTemplate.length);

    // Reemplazar los placeholders con los datos de la multa
    const replacements = {
      // Campos básicos
      '{{FOLIOx}}': multaData.folio || '',
      '{{FOLIO}}': multaData.folio || '',
      '{{FECHA_EMISION}}': multaData.fechaInfraccion ? new Date(multaData.fechaInfraccion).toLocaleDateString() : new Date().toLocaleDateString(),
      '{{FECHA_INFRACCION}}': multaData.fechaInfraccion ? new Date(multaData.fechaInfraccion).toLocaleDateString() : '',
      '{{LUGAR_HECHOS}}': (multaData as any).lugarHechos || multaData.lugarInfraccion || '',
      '{{LUGAR_INFRACCION}}': multaData.lugarInfraccion || '',
      '{{LATITUD}}': multaData.latitud?.toString() || '',
      '{{LONGITUD}}': multaData.longitud?.toString() || '',
      
      // Información del vehículo y conductor
      '{{NUMERO_PLACA}}': multaData.numeroPlaca || '',
      '{{PLACAS}}': (multaData as any).placas || multaData.numeroPlaca || '',
      '{{VIGENCIA}}': multaData.vigencia || '',
      '{{TIPO_VEHICULO}}': multaData.tipoVehiculo || '',
      '{{ENTIDAD}}': multaData.entidad || '',
      
      // Datos del vehículo
      '{{MARCA}}': multaData.marca || '',
      '{{MODELO_VEHICULO}}': multaData.modeloVehiculo || '',
      '{{MODELO}}': multaData.modeloVehiculo || '',
      '{{TIPO}}': multaData.tipo || '',
      '{{TIPO_VEH}}': multaData.tipo || '',
      '{{TIPO_MULTA}}': multaData.tipo || 'Tránsito',
      '{{COLOR}}': multaData.color || '',
      '{{PLACAS_CIRCULACION}}': multaData.placasCirculacion || '',
      
      // Información del conductor/propietario
      '{{CIUDADANO}}': multaData.ciudadano || '',
      '{{CONTRIBUYENTE}}': multaData.ciudadano || '',
      '{{PROPIETARIO_VEHICULO}}': multaData.propietarioVehiculo || '',
      '{{DOMICILIO_CONDUCTOR}}': multaData.domicilioConductor || '',
      '{{DOMICILIO}}': multaData.domicilioConductor || '',
      
      // Información de la infracción
      '{{ARTICULO_VIOLADO}}': multaData.articuloViolado || '',
      '{{FRACCION}}': multaData.fraccion || '',
      '{{DESCRIPCION}}': multaData.descripcion || '',
      '{{DESCRIPCION_1}}': multaData.descripcion || `Multa por ${multaData.tipo || 'infracción'}`,
      
      // Información del oficial
      '{{NOMBRE_OFICIAL}}': multaData.nombreOficial || '',
      '{{GRADO_OFICIAL}}': multaData.gradoOficial || '',
      
      // Información financiera y administrativa
      '{{MONTO}}': `$${multaData.monto?.toFixed(2) || '0.00'}`,
      '{{ESTATUS}}': multaData.estatus || 'PENDIENTE',
      '{{ESTADO_PAGO}}': multaData.estatus || 'PENDIENTE',
      '{{GARANTIA}}': multaData.garantia || '',
      
      // Campos de pago
      '{{CONCEPTO_1}}': `Multa de Tránsito - ${multaData.tipo || ''}`,
      '{{IMPORTE_1}}': `$${multaData.monto?.toFixed(2) || '0.00'}`,
      '{{SUBTOTAL}}': `$${multaData.monto?.toFixed(2) || '0.00'}`,
      '{{RECARGOS}}': '$0.00',
      '{{DESCUENTOS}}': '0.00',
      '{{TOTAL}}': `$${multaData.monto?.toFixed(2) || '0.00'}`,
      
      // Metadatos
      '{{FECHA}}': multaData.fecha ? new Date(multaData.fecha).toLocaleDateString() : '',
      '{{CREADA_EN}}': multaData.creadaEn ? new Date(multaData.creadaEn).toLocaleDateString() : '',
      '{{ACTUALIZADA_EN}}': multaData.actualizadaEn ? new Date(multaData.actualizadaEn).toLocaleDateString() : '',
      
      // Campos adicionales para el sistema
      '{{PERIODO}}': new Date().getFullYear().toString(),
      '{{VIGENCIA_PAGO}}': new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toLocaleDateString(),
      '{{REFERENCIA}}': multaData.folio || '',
      '{{LINEA_CAPTURA}}': `${multaData.folio}${Math.floor(Math.random() * 10000)}`
    };

    // Reemplazar todos los placeholders
    Object.entries(replacements).forEach(([placeholder, value]) => {
      htmlTemplate = htmlTemplate.replace(new RegExp(placeholder, 'g'), value);
    });

    console.log('HTML final generado, longitud:', htmlTemplate.length);
    
    // Crear una nueva ventana para imprimir
    console.log('Abriendo ventana de impresión...');
    const printWindow = window.open('', '_blank');
    if (printWindow) {
      console.log('Ventana abierta exitosamente');
      printWindow.document.write(htmlTemplate);
      printWindow.document.close();
      
      // Esperar a que se cargue completamente antes de imprimir
      printWindow.onload = () => {
        console.log('Ventana cargada, iniciando impresión en 500ms...');
        setTimeout(() => {
          console.log('Ejecutando print()...');
          printWindow.print();
        }, 500);
      };
    } else {
      throw new Error('No se pudo abrir la ventana de impresión. Verifica que los popups estén habilitados.');
    }
    
    console.log('=== PDF GENERADO EXITOSAMENTE ===');
  } catch (error) {
    console.error('=== ERROR GENERANDO PDF ===');
    console.error('Error completo:', error);
    if (error instanceof Error) {
      console.error('Stack trace:', error.stack);
    }
    throw error;
  }
};